import { allFields, fields, orderingAndLimit } from "./variables"

export const getBySlug = () =>
  groq`*[_type == 'opportunities' && slug.current == $slug][0]${allFields}`

export const getById = () =>
  groq`*[_type == 'opportunities' && _id == $id][0]${allFields}`

export const searchByTerm = () => {
  const filter = `_type == 'opportunities' &&
    visibility == true &&
    (
      title match $term ||
      title match $normalizedTerm ||
      description match $term ||
      description match $normalizedTerm ||
      country->name match $term ||
      country->name match $normalizedTerm ||
      country->code match $term ||
      country->code match $normalizedTerm ||
      city->name match $term ||
      city->name match $normalizedTerm ||
      brand->name match $term ||
      brand->name match $normalizedTerm ||
      count(country->alias[lower(@) match lower($term)]) > 0 ||
      count(city->alias[lower(@) match lower($term)]) > 0
    )`

  const { getFirstPage, getNextPage } = queries(
    filter,
    orderingAndLimit,
    fields,
  )

  return {
    getFirstPage,
    getNextPage,
  }
}
